import { Button, Skeleton } from '@augmentt-dev/ui-components'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import Pill from '../Pill'
import SelectablePill from '../SelectablePill'

const propTypes = {
  /**
   * Items of the PillList.
   * Similar to the options passed to react-select
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.node.isRequired,
    }),
  ),
  /**
   * Callback called when an item is removed
   */
  onRemoval: PropTypes.func.isRequired,
  /**
   * If true, presents a loading animation
   */
  loading: PropTypes.bool,
  /**
   * Limit the number of items being shown.
   * If passed will show a 'show more' button to toggle the visibility of the excess items
   */
  maxItems: PropTypes.number,
  /**
   * If true, hides pill with 'None' label if there are no items in the list
   */
  hideNoneLabel: PropTypes.bool,
}

function PillList(props) {
  const { items = [], onRemoval, loading = false, maxItems = undefined, hideNoneLabel = false } = props ?? {}
  const [showAllItems, setShowAllItems] = useState(false)

  let itemsToShow = items
  if (maxItems && !showAllItems) {
    itemsToShow = items.slice(0, maxItems)
  }

  if (loading) {
    return <Skeleton />
  }

  if (!hideNoneLabel && !items?.length) {
    return (
      <Pill textGray>
        <FormattedMessage id="GENERAL.NONE" />
      </Pill>
    )
  }

  return (
    <>
      {itemsToShow.map((item) => (
        <SelectablePill key={item.value} selected onChange={() => onRemoval(item.value)}>
          {item.label}
        </SelectablePill>
      ))}
      {maxItems && items?.length > maxItems ? (
        <Button variant="link" onClick={() => setShowAllItems(!showAllItems)}>
          {showAllItems ? (
            <FormattedMessage id="GENERAL.SHOW_LESS" />
          ) : (
            <span>
              <FormattedMessage id="GENERAL.SHOW_ALL" />
              &nbsp;(+{items.length - maxItems})
            </span>
          )}
        </Button>
      ) : null}
    </>
  )
}

PillList.propTypes = propTypes

export default PillList
